import Checkbox from '@atlaskit/checkbox';
import { Box } from '@atlaskit/primitives';
import { defaultStoreUtils } from '@databases/redux';
import { addChangeToDraft } from '@databases/redux/changesets/actions';
import { DatabaseFieldType } from '@databases/types/database';
import { DatabaseChangeType } from '@databases/types/redux';
import React, { type FunctionComponent, useCallback } from 'react';

import { getExperimentValue } from '@canvas/client-feature-flags/experiments';

import { type ViewComponentProps } from '../view/types';

import { type EditComponentProps } from './types';

type CheckboxValueEditProps = ViewComponentProps<DatabaseFieldType.CHECKBOX> & {
  onChange?: EditComponentProps<DatabaseFieldType.CHECKBOX>['onChange'];
};

const CheckboxValueEdit: FunctionComponent<CheckboxValueEditProps> = ({
  field,
  contentId,
  value,
  entryId,
  onChange,
}) => {
  const dispatch = defaultStoreUtils.useDispatch();
  const isCheckboxEnabled = getExperimentValue('checkboxFieldType', 'enabled', {
    fireExperimentExposure: false,
  });
  const toggleCheckbox = useCallback(() => {
    if (onChange) {
      onChange(!value, {
        type: DatabaseFieldType.CHECKBOX,
        value: !value,
      });
    } else {
      dispatch(
        addChangeToDraft(contentId, 'main', {
          type: DatabaseChangeType.SET_VALUE,
          fieldId: field.id,
          entryId: entryId as string,
          value: {
            type: DatabaseFieldType.CHECKBOX,
            value: !value,
          },
          change: {
            type: DatabaseFieldType.CHECKBOX,
            value: !value,
          },
        })
      );
    }
  }, [contentId, dispatch, entryId, field.id, onChange, value]);

  return (
    <Box padding="space.025">
      <Checkbox
        testId="databases-checkbox"
        isChecked={value}
        onChange={toggleCheckbox}
        isDisabled={!isCheckboxEnabled}
        size="large"
      ></Checkbox>
    </Box>
  );
};
export default CheckboxValueEdit;
